import FadeIn from "./FadeIn";
import { C } from "./brandTokens";

const rows = [
  {
    numeral: "I.",
    headline: "You've tried the apps.",
    body: "Hallow, YouVersion, Day One, Pray.com, bullet journals. You loved them for two weeks. You were journaling alone by day twenty.",
  },
  {
    numeral: "II.",
    headline: "You're grieving, and church has run its course.",
    body: "The sermons landed and the casseroles came. Now it's 6am and the silence in the house is louder than anything the small group could say.",
  },
  {
    numeral: "III.",
    headline: "You're returning after a long time away.",
    body: "You don't belong in a fellowship group yet. You want a quiet place to rebuild something, without anyone watching while you do it.",
  },
  {
    numeral: "IV.",
    headline: "Your devotional life has become maintenance.",
    body: "You read the verse. You close the app. Nothing reaches you. You're not sure if this is doubt or just exhaustion — but you keep showing up.",
  },
  {
    numeral: "V.",
    headline: "You want depth, not another streak.",
    body: "You read Nouwen, Rohr, Marilynne Robinson, Tish Harrison Warren. You don't want gamified prayer. You want something that takes the interior life seriously.",
  },
  {
    numeral: "VI.",
    headline: "You're wary of AI, but open if it's done carefully.",
    body: "You can tell when software cares about what it's handling. You'd rather see a thoughtful tool than an avoidant one — if the tool knows what it is and what it isn't.",
  },
];

export default function AudienceSection() {
  return (
    <section
      id="who-its-for"
      className="py-[120px] px-6 sm:px-10"
      style={{ background: C.cream }}
    >
      <div className="max-w-[780px] mx-auto">

        {/* Section heading */}
        <FadeIn className="text-center" style={{ marginBottom: 80 }}>
          <p
            className="font-ui"
            style={{
              fontSize: 11,
              color: C.txt3,
              letterSpacing: "1.4px",
              marginBottom: 20,
            }}
          >
            WHO THIS IS FOR
          </p>
          <h2
            className="font-heading font-semibold text-spec-brown mx-auto text-center"
            style={{
              fontSize: "clamp(34px, 4.2vw, 52px)",
              lineHeight: 1.12,
              maxWidth: 640,
            }}
          >
            You probably found us because
            <br />
            <em className="italic text-spec-sage">one of these is you.</em>
          </h2>
        </FadeIn>

        {/* Six self-select rows */}
        <div className="max-w-[620px] mx-auto">
          {rows.map((r, i) => (
            <FadeIn key={i} delay={i * 0.05}>
              <div
                className="flex items-start"
                style={{
                  gap: 20,
                  paddingTop: 28,
                  paddingBottom: 28,
                  borderBottom:
                    i < rows.length - 1 ? `1px solid ${C.bdr}` : "none",
                }}
              >
                {/* Roman numeral marker */}
                <div
                  className="font-heading italic"
                  style={{
                    fontSize: 14,
                    color: C.sageMuted,
                    letterSpacing: "0.3px",
                    width: 60,
                    flexShrink: 0,
                    paddingTop: 2,
                  }}
                >
                  {r.numeral}
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3
                    className="font-heading font-semibold"
                    style={{
                      color: C.brown,
                      fontSize: "clamp(18px, 2vw, 22px)",
                      lineHeight: 1.3,
                      marginBottom: 8,
                    }}
                  >
                    {r.headline}
                  </h3>
                  <p
                    className="font-ui m-0"
                    style={{
                      fontSize: 14,
                      lineHeight: 1.75,
                      color: C.txt2,
                    }}
                  >
                    {r.body}
                  </p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>

        {/* Footer line */}
        <FadeIn delay={0.2} style={{ marginTop: 64 }} className="text-center">
          <p
            className="font-heading italic mx-auto m-0"
            style={{
              fontSize: "clamp(17px, 2vw, 20px)",
              color: C.txt2,
              lineHeight: 1.8,
              maxWidth: 540,
            }}
          >
            If any of that is you — welcome. Eden Pages was built for exactly this.
          </p>
        </FadeIn>

      </div>
    </section>
  );
}
